export const SEARCH_PATIENT_REQUEST = 'SEARCH_PATIENT_REQUEST';
export const SEARCH_PATIENT_SUCCESS = 'SEARCH_PATIENT_SUCCESS';
export const SEARCH_PATIENT_FAIL = 'SEARCH_PATIENT_FAIL';
// GET SINGLE PATIENT
export const GET_PATIENT_REQUEST = 'GET_PATIENT_REQUEST';
export const GET_PATIENT_SUCCESS = 'GET_PATIENT_SUCCESS';
export const GET_PATIENT_FAIL = 'GET_PATIENT_FAIL';
export const GET_PATIENT_RESET = 'GET_PATIENT_RESET';